import type { GetActionByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetActionByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetActionByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetActionByIdArgs = {
  id: string;
};

export const useLazyGetActionById = createLazyQueryHook<
  UseLazyGetActionByIdArgs,
  GetActionByIdResponseRow[],
  GetActionByIdQuery
>({
  trpcQuery: (client, { id }) =>
    client.frontend.action.actionById.query({ id }),
  mapTrpcDataToGraphQL: (data) => ({ action: data }),
  graphqlDocument: GetActionByIdDocument,
  graphqlVariables: ({ id }) => ({ _eq: id }),
});
